/* bb-home-quickadd.js — homepage "Add" buttons + option bottom-sheet.
   Delegates the actual cart mutation to window.BBCart.addBundle (bb-cart-add.js),
   which is the same verified, bundle-aware sequence the PDP uses. On success the
   shared cart drawer slides out via the cart:added / bb:cart:open events.

   Event-delegated + idempotent so it can be loaded from more than one section
   (range grid + 4-stage system CTA) without double-binding. */

(function () {
  'use strict';
  if (window.__bbQAInit) return;
  window.__bbQAInit = true;

  var lastTrigger = null;

  function openSheet(sheet, trigger) {
    lastTrigger = trigger || null;
    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    // next frame so the transition runs from the hidden state
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    document.documentElement.classList.add('hp-qa-lock');
    var focusable = sheet.querySelector('[data-bb-qa-add], [data-bb-qa-close]');
    if (focusable) { try { focusable.focus(); } catch (e) {} }
  }

  function closeSheet(sheet) {
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hp-qa-lock');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      sheet.hidden = true;
    };
    sheet.addEventListener('transitionend', finish, { once: true });
    // Fallback in case transitionend doesn't fire (reduced motion, display none, etc.)
    setTimeout(finish, 400);
    if (lastTrigger) { try { lastTrigger.focus(); } catch (e) {} }
    lastTrigger = null;
  }

  function parseGifts(attr) {
    if (!attr) return [];
    try {
      var arr = JSON.parse(attr);
      return Array.isArray(arr) ? arr.filter(function (n) { return typeof n === 'number' && n > 0; }) : [];
    } catch (e) { return []; }
  }

  function doAdd(btn) {
    if (btn.classList.contains('is-loading') || btn.disabled) return;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var bundleId = btn.getAttribute('data-bundle-id') || '';
    var gifts = parseGifts(btn.getAttribute('data-gifts'));
    if (!variantId) return;

    // Graceful fallback if the cart module didn't load — send them to the PDP.
    if (!window.BBCart || typeof window.BBCart.addBundle !== 'function') {
      if (bundleId) window.location.href = '/products/' + bundleId;
      return;
    }

    btn.classList.add('is-loading');
    window.BBCart.addBundle({ variantId: variantId, bundleId: bundleId, giftIds: gifts, qty: 1 })
      .then(function () {
        btn.classList.remove('is-loading');
        var sheet = btn.closest('[data-bb-qa-sheet]');
        if (sheet) closeSheet(sheet);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        if (window.console) {
          console.error('[bb-quick-add] add failed:', err && err.shopify ? err.shopify : err);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bb-qa-trigger]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('aria-controls');
      var sheet = id && document.getElementById(id);
      if (sheet) openSheet(sheet, trigger);
      return;
    }
    var closeEl = e.target.closest('[data-bb-qa-close]');
    if (closeEl) {
      e.preventDefault();
      var sheetC = closeEl.closest('[data-bb-qa-sheet]');
      if (sheetC) closeSheet(sheetC);
      return;
    }
    var addBtn = e.target.closest('[data-bb-qa-add]');
    if (addBtn) {
      e.preventDefault();
      doAdd(addBtn);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-bb-qa-sheet].is-open');
    if (open) closeSheet(open);
  });
})();
